import { Vue } from 'vue-property-decorator';
import moment from 'moment';
import { GlobalVariables } from '@/libs/core/global';

Vue.filter('formatMoment', (value : string, format: string) => {
    if (value) {
        moment.locale(GlobalVariables.lang);
        return moment(String(value)).locale(GlobalVariables.lang).format(format);
    }
})